import React from 'react';
import { NavLink } from "react-router-dom";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const MenuNode = (props) => {
	const { linkIndex, linkTo, linkTitle, itemIcon, open } = props;

	const getClassName = ({ isActive }) => `menu-item ${isActive ? 'active' : ''}`;

	if (linkIndex) {
		return (
			<li>
				<NavLink to="/" className={getClassName}>
					{(!open && !navigator.userAgent.match(/(iPad)/))
						? <OverlayTrigger
							placement="right"
							delayHide={100}
							overlay={
								<Tooltip id="sidemenu-tooltip" className="tooltip custom-tooltips">
									{linkTitle}
								</Tooltip>
							}
						>
							{itemIcon}
						</OverlayTrigger>
						: itemIcon
					}
					<div className="text">{linkTitle}</div>
				</NavLink>
			</li>
		)
	}

	return (
		<li>
			<NavLink to={linkTo} className={getClassName}>
				{(!open && !navigator.userAgent.match(/(iPad)/))
					? <OverlayTrigger
						placement="right"
						delayHide={100}
						overlay={
							<Tooltip id="sidemenu-tooltip" className="tooltip custom-tooltips">
								{linkTitle}
							</Tooltip>
						}
					>
						{itemIcon}
					</OverlayTrigger>
					: itemIcon
				}
				<div className="text">{linkTitle}</div>
			</NavLink>
		</li>
	)
}

export default MenuNode;
